export enum JobScheduleType {
  GENERAL = 0,
  INSPECTION = 1,
  MAINTENANCE = 3,
  WORK_ORDER = 4
}

export enum JobScheduleLabelType {
  GENERAL = 'General',
  INSPECTION = 'Inspection',
  WORK_ORDER = 'Purchase order',
  MAINTENANCE = 'Maintenance'
}

export default JobScheduleType
